module.exports = __webpack_public_path__ + "assets/img/69_519_1.cef40f36.jpg";